import moment from "moment";

const subtractMonths = (input, months) => {
  return new Date(moment(input).subtract(months, "M"));
};

export default subtractMonths;
